<template>
  <div>
    <CustomModal 
    :type="modal.type"
    :open="modal.open"
    @close-modal="modal.open = false">
      <template slot="modal_content">
        <p class="notification-text">{{modal.message}}</p>
      </template>
    </CustomModal>

    <CustomModal 
    :type="'success'"
    :open="forgot_password_modal.open_success"
    @close-modal="forgot_password_modal.open_success = false">
      <template slot="modal_content">
        <p>{{$_('reinit_success')}}</p>
      </template>
    </CustomModal>

    <CustomModal 
    :open="forgot_password_modal.open"
    :title="$_('change_password_title')"
    :size="'xs'"
    :keepratio="true"
    @close-modal="forgot_password_modal.open = false">
      <template slot="modal_content">
        <div class="email-container">
          <div class="form-field">
            <label>{{$_('your_email')}}</label>
            <input type="email" v-model="forgot_password_modal.email" /> 
          </div>
        </div>
        <div class="error-message">
          <p>{{forgot_password_modal.error_message}}</p>
        </div>
      </template>
      <template slot="modal_footer">
        <span class="btn" @click="vValidateEmail">{{$_('validate')}}</span>
      </template>
    </CustomModal>

    <form @submit.prevent="vSingIn">
      <div class="form-field">
        <label for="username">{{$_('username')}}</label>
        <input type="email" id="username" v-model="signInInfo.username" placeholder="xxx@xxx.com" />
      </div>
      <div class="form-field">
        <label for="username">{{$_('password')}}</label>
        <input type="password" id="password" v-model="signInInfo.password" />
      </div>
      <input type="submit" class="btn-connect" :value="$_('to_log_in')" />
    </form>
    <span @click="forgot_password_modal.open = true" class="italic mdp-oublie">{{$_('forgot_password')}}</span>
  </div>
</template>

<script>

import authService from "../services/authService";

import CustomModal from '@/common/components/widget/Modal/CustomModal';

export default {
  name: 'SignIn',
  data() {
    return {
      signInInfo: {
        username: "",
        password: ""
      },
      modal: {
        open: false,
        type: 'default',
        message: ''
      },
      forgot_password_modal: {
        open: false,
        open_success: false,
        email: '',
        error_message: ''
      }
    }
  },
  components: {
    CustomModal
  },
  methods: {
    vSingIn() {
      authService
        .authSignin(this.signInInfo)
        .then(res => {
          if (res.data.error !== undefined && res.data.error === 1) {
           
            this.modal.open = true;
            this.modal.type = 'error';
            this.modal.message = res.data.error_message;

          }
          if (res.data.response.pretour !== 1) {
      
            this.modal.open = true;
            this.modal.type = 'error';
            this.modal.message = res.data.error_message;

          } else {
            let userData = {
              id: res.data.response.pid,
              username: res.data.response.username,
              lang: res.data.response.lang
            };
            this.$store.dispatch("application/SATABAPP_STORE", {
              key: "satabapp-token",
              val: res.data.response.token
            });
            this.$store.dispatch("application/SATABAPP_STORE", {
              key: "satabapp-user",
              val: userData
            });
            this.$store.dispatch("application/SATABAPP_STORE", {
              key: "satabapp-translation",
              val: res.data.response.translation
            });

            this.$router.push("/liste-societe");
          }
        })
        .catch(err => {
          console.error(err);
      });
    },
    vValidateEmail() {
      authService.getValidateEmail(this.forgot_password_modal.email)
      .then(res => {
        if(res.data !== undefined && res.data.POK === 1) {
          this.forgot_password_modal.error_message = '';
          this.forgot_password_modal.open = false;

          this.forgot_password_modal.open_success = true;

        } else {
          this.forgot_password_modal.error_message = this.$_('email_not_exist')
        }
      });
    }
  }
};
</script>

<style scoped>
.btn-connect {
  margin-top: 40px;
}
.mdp-oublie {
  font-size: 1rem;
  color: #8b8b8b;
  margin-top: 40px;
  display: inline-block;
}
#auth-form-container {
  margin-top: 60px;
  margin-bottom: 30px;
}
#auth-signin form {
  max-width: 70%;
}
.notification-text {
  text-align: center;
  color: #b61827;
}
.error-message p {
  color: #ef5350;
  font-size: var(--fz-md);
}
.mdp-oublie:hover {
  cursor: pointer;
  text-decoration: underline;
}

@media screen and (max-width: 800px){
  #auth-signin form {
    max-width: 100%;
  }
}
</style>